import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";

const createAppointment = async ({ data }) => {
  const token = localStorage.getItem("token");

  const createData = {
    patient: data.patient,
    appointment_duration: data.duration,
    notes: data.notes,
    appointment_time: data.time,
    appointment_status: "UPCOMING",
    appointment_clinic: data.clinic,
    practitioner: data.practitioner,
    appointment_notify_push: data.notifypush,
    appointment_notify_email: data.notifyemail,
    appointment_notify_sms: data.notifysms,
    appointment_type: data.type,
    existing_appointment_types: data.appointment_type_list,
  };

  const response = await axios.post(
    `${__API_URL__}/api/appointments/create_appointment`,
    createData,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useCreateAppointmentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createAppointment,
    onSuccess: () => {
      toast.success("Appointment Created!");
      queryClient.invalidateQueries({ queryKey: ["patient_appointments"] });
    },
    onError: (error) => {
      console.error("Failed to create appointment:", error);
    },
  });
};

export default useCreateAppointmentMutation;
